// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"74cea09a","2013":"df11c806","3256":"85dc6364","6919":"238a5610"}[chunkId] + ".chunk.css";
};